export default "__VITE_ASSET__20OxBxw2__"